import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import GamificationService from 'services/GamificationService'
import { buildAccessProfile } from 'auth/permissions'

const EMPTY = []

const useAccessProfile = () => {
  const token = useSelector(state => state.auth.token)
  const [memberships, setMemberships] = useState(EMPTY)
  const [loading, setLoading] = useState(Boolean(token))

  useEffect(() => {
    let mounted = true
    if (!token) {
      setMemberships(EMPTY)
      setLoading(false)
      return () => { mounted = false }
    }

    setLoading(true)
    GamificationService.list('access-control/memberships')
      .then(data => {
        if (mounted) setMemberships(Array.isArray(data) ? data : EMPTY)
      })
      .catch(() => {
        if (mounted) setMemberships(EMPTY)
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })

    return () => { mounted = false }
  }, [token])

  const profile = useMemo(() => buildAccessProfile(token, memberships), [token, memberships])
  return { profile, memberships, loading }
}

export default useAccessProfile
